import React from 'react';
import HeadersNonAuth from '../../components/base/HeadersNonAuth';

const CompanyPage = () => {
  return (
    <div className="bg-[#0b0d2a] text-white font-sans min-h-screen">
      <HeadersNonAuth />
      <br />
      <br />
      <br />
      <br />    
      <br />
      <br />   
       <br />
      <section id="company" className="bg-[#0b0d2a] text-white px-6 lg:px-24 py-10 font-sans mb-16">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl sm:text-4xl font-bold mb-8">About JTNC Group</h2>

          <h3 className="text-xl font-bold mb-2">Decades of Experience. One Mission: Empower the Modern Trader.</h3>
          <p className="mb-4">
            At JTNC Group, we bring together <strong>over 20 years of real-world trading experience</strong> with a relentless drive to deliver institutional-quality tools to individual investors. Our founders have managed the movement of <strong>tens of millions of dollars across global markets</strong>, leading trading desks, building hedge fund strategies, and advising clients through every type of market condition, from bubbles to breakdowns.
          </p>
          <p className="mb-6">
            That depth of experience isn't theoretical, it's lived, earned, and embedded into everything we build.
          </p>

          <hr className="border-gray-700 my-10" />

          <h3 className="text-xl font-bold mb-2">Bridging the Gap Between Retail and Institutional</h3>
          <p className="mb-4">
            What sets JTNC Group apart isn't just our trading pedigree, it's our <strong>vision for the future</strong> of retail trading. We've built a proprietary technology stack that leverages machine learning, predictive analytics, and advanced market structure analysis tools that were once the exclusive domain of hedge funds and investment banks.
          </p>
          <p className="mb-6">
            With our platform, we bring this edge to <strong>individual traders</strong>. Our mission is to <strong>democratize alpha</strong>, providing everyday investors access to powerful tools once reserved for institutions.
          </p>

          <hr className="border-gray-700 my-10" />

          <h3 className="text-xl font-bold mb-2">Where Insight Meets Innovation</h3>
          <p className="mb-4">
            Whether you're new to trading or a seasoned professional, our ecosystem is designed to help you succeed:
          </p>
          <ul className="list-disc pl-6 mb-6 space-y-2">
            <li><strong>Proprietary signal generation backed by statistical edge</strong></li>
            <li><strong>Battle-tested models built for dynamic markets</strong></li>
            <li><strong>Automated execution with full user control</strong></li>
            <li><strong>Education and support from a team that's traded through it all</strong></li>
          </ul>
          <p className="mb-6">
            We don't just sell signals. We provide the infrastructure, the logic, and the <strong>confidence</strong> to help you trade smarter and win more often.
          </p>

          <hr className="border-gray-700 my-10" />

          <p className="font-bold text-lg mb-2">At JTNC Group, we don't follow the market. We anticipate it.</p>
          <p>
            Join us and experience what happens when <strong>decades of expertise</strong> meets <strong>cutting-edge automation</strong> purpose-built to help you thrive in today's markets.
          </p>
        </div>
      </section>
    </div>
  );
};

export default CompanyPage;
